//Angular imports
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

//3rd party imports
import { plainToInstance } from 'class-transformer';

//RxJs imports
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

//Service imports
import { RPCacheRegistrationService } from '../../../_services/shared-services/rp-cache-registration-service';

//Model imports
import { BaseResidentParameterDto } from '../../../_models/base-resident-parameter-dto';
import { DocumentParamterDto } from '../../_models/document-parameter-dto';
import { DocumentResultDto } from '../../_models/document-result-dto';
import { DocumentTreeResultDto } from '../../_models/document-tree-result-dto';

//Service imports
import { EnvironmentConfigService } from '../../../_services/environment-config.service';

//Constants imports
import { CacheDuration } from '../../../_constants/cache-duration';

@Injectable({
  providedIn: 'root'
})
export class DocumentService {
  constructor(
    private httpClient: HttpClient,
    private cacheRegistrationService: RPCacheRegistrationService,
    private envConfig: EnvironmentConfigService
  ) {}

  getDocumentTree(
    data: BaseResidentParameterDto
  ): Observable<DocumentTreeResultDto[]> {
    const url =
      this.envConfig.ccResidentPortalApiUrl +
      'account/documents/tree' +
      data.getQueryString();
    this.cacheRegistrationService.registerForCache(url, data.clearCache);
    const headers = this.cacheRegistrationService.getHttpRequestHeaders(
      url,
      CacheDuration.fifteenMinute
    );
    const options = { headers: headers };

    return this.httpClient
      .get<DocumentTreeResultDto[]>(url, options)
      .pipe(
        map((responseData: DocumentTreeResultDto[]) =>
          plainToInstance(DocumentTreeResultDto, responseData)
        )
      );
  }

  getDocumentList(data: DocumentParamterDto): Observable<DocumentResultDto[]> {
    const url =
      this.envConfig.ccResidentPortalApiUrl +
      'account/documents/list' +
      data.getQueryString();
    this.cacheRegistrationService.registerForCache(url, data.clearCache);
    const headers = this.cacheRegistrationService.getHttpRequestHeaders(
      url,
      CacheDuration.fifteenMinute
    );
    const options = { headers: headers };

    return this.httpClient
      .get<DocumentResultDto[]>(url, options)
      .pipe(
        map((responseData: DocumentResultDto[]) =>
          plainToInstance(DocumentResultDto, responseData)
        )
      );
  }

  downloadFile(fileUrl: string): Observable<Blob> {
    return this.httpClient
      .get(fileUrl, { responseType: 'arraybuffer' })
      .pipe(map((responseData: any) => new Blob([responseData])));
  }
}
